








import { Component, Vue } from 'vue-property-decorator';

@Component({})
export default class SideButton extends Vue {
  private goToTop() {
    (document.body as HTMLBodyElement).scrollTop = 0;
    (document.documentElement as HTMLElement).scrollTop = 0;
  }
}
